<template>
  <div
    ref="kt_modal_fornecedores_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_fornecedores_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <ConsultarFornecedor
            ref="ConsultarFornecedor"
            :modal="true"
            @selecionarFornecedor="selecionarFornecedor"
            @fecharFornecedor="modalConsultarFornecedor"
            @adicionarFornecedor="adicionarFornecedor"
            @editarFornecedor="editarFornecedor"
          ></ConsultarFornecedor>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarFornecedor"
    ref="kt_modal_fornecedores_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_fornecedores_editar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen055.svg" />
            </span>
            <h3
              class="fw-bold m-0 text-gray-800"
              v-if="this.idFornecedor === 0"
            >
              Adicionar Fornecedor
            </h3>
            <h3 class="fw-bold m-0 text-gray-800" v-else>Editar Fornecedor</h3>
          </div>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarFornecedor(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarFornecedor
            :modal="true"
            @cancelarFornecedor="modalEditarFornecedor"
            @confirmarFornecedor="confirmarFornecedor"
            :idFornecedor="idFornecedor"
          ></EditarFornecedor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultarFornecedor from "@/views/fornecedores/Consultar.vue";
import EditarFornecedor from "@/views/fornecedores/Editar.vue";
import {
  hideModal,
  showModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["selecionarFornecedor", "exibirModalFornecedores"],
  components: {
    ConsultarFornecedor,
    EditarFornecedor,
  },
  methods: {
    modalConsultarFornecedor(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalFornecedores", false);
      }
    },
    selecionarFornecedor(fornecedor) {
      this.$emit("selecionarFornecedor", fornecedor);
      this.modalConsultarFornecedor(false);
      hideModal(this.$refs.kt_modal_fornecedores_consultar);
    },
    adicionarFornecedor() {
      this.idFornecedor = 0;
      this.modalEditarFornecedor(true);
    },
    editarFornecedor(id) {
      this.idFornecedor = id;
      this.modalEditarFornecedor(true);
    },
    modalEditarFornecedor(exibir) {
      this.exibirEditarFornecedor = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_fornecedores_editar");
        }, 100);
      }
    },
    confirmarFornecedor() {
      this.modalEditarFornecedor(false);
      hideModal(this.$refs.kt_modal_fornecedores_editar);
      this.$refs.ConsultarFornecedor.loadData();
    },
  },
  data() {
    return {
      idFornecedor: 0,
      exibirEditarFornecedor: false,
    };
  },
};
</script>

<style></style>
